module.exports = __webpack_public_path__ + "static/media/menu.c9ca8f08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu.svg
// module id = 298
// module chunks = 0